var map = {
	"./bh-ico-active.svg": 1784,
	"./bh-ico.svg": 1785,
	"./bonus-ico-active.svg": 1786,
	"./bonus-ico.svg": 1787,
	"./deposit-ico.svg": 1788,
	"./deposit-ico.webp": 1789,
	"./edit-icon.svg": 1790,
	"./fb-ico.svg": 1791,
	"./instant-rebate-ico-active.svg": 1792,
	"./instant-rebate-ico.svg": 1793,
	"./mall-ico-active.svg": 1794,
	"./mall-ico.svg": 1795,
	"./msg-ico-active.svg": 1796,
	"./msg-ico.svg": 1797,
	"./pi-ico-active.svg": 1798,
	"./pi-ico.svg": 1799,
	"./rf-ico-active.svg": 1800,
	"./rf-ico.svg": 1801,
	"./rh-ico-active.svg": 1802,
	"./rh-ico.svg": 1803,
	"./th-ico-active.svg": 1804,
	"./th-ico.svg": 1805,
	"./vip-ico-active.svg": 1806,
	"./vip-ico.svg": 1807,
	"./withdrawal-ico.svg": 1808,
	"./withdrawal-ico.webp": 1809,
	"./wl-ico-active.svg": 1810,
	"./wl-ico.svg": 1811
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 473;